import { __rest } from './../../../../external/tslib/tslib.es6.js';
import React from 'react';
import { Box, SplashFeedback } from '@olist/design-system';
import Dog from '../../../Images/dog.svg.js';
import QuestionBox from '../../../Images/question-box.svg.js';

function TableState(_a) {
    var { state, subtitle, text } = _a, props = __rest(_a, ["state", "subtitle", "text"]);
    const imageByState = {
        blank: QuestionBox,
        error: Dog,
    };
    return (React.createElement(Box, Object.assign({ mt: "120px" }, props),
        React.createElement(SplashFeedback, { image: imageByState[state], title: text !== null && text !== void 0 ? text : '', subtitle: subtitle !== null && subtitle !== void 0 ? subtitle : '' })));
}

export { TableState };
